import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InputProps } from "reactstrap";
import Select from "react-select";

import { SelectListDto } from "../../models";
import { useGetCourseAndGradesSelectListQuery } from "../../store/api/courseApi";
import { useGetFeatureSelectListQuery } from "../../store/api/featureApi";

type TProps = InputProps & {
  isMulti?: boolean;
  closeMenuOnSelect?: boolean;
  value: any;
  onChange: (values: any) => void;
  placeholder: string;
};

export const FeaturesSelect: React.FC<TProps> = ({
  onChange,
  value,
  closeMenuOnSelect = true,
  isMulti = false,
  placeholder,
}) => {
  const { t, i18n } = useTranslation();

  const { data, error, isSuccess } = useGetFeatureSelectListQuery();
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    if (error) {
      const errMsg =
        "status" in error
          ? (error.data as any)?.message || "An error occurred"
          : "An error occurred";
      toast.error(errMsg, {
        autoClose: 3000,
      });
    }
  }, [error]);

  useEffect(() => {
    if (isSuccess && data) {
      var mappedOptions = data?.map((item: SelectListDto) => {
        return {
          label: i18n.language === "ar" ? item.value.ar : item.value.en,
          value: item.id,
        };
      });
      setOptions(mappedOptions);
    }
  }, [data, isSuccess, i18n.language]);

  return (
    <Select
      placeholder={t(placeholder)}
      closeMenuOnSelect={closeMenuOnSelect}
      value={value}
      onChange={onChange}
      isMulti={isMulti}
      options={options}
    />
  );
};
